import { FC } from 'react';
import { css } from '@emotion/react';
import { UserDetails } from '@weave/schema-gen-ts/dist/schemas/auth-api/v3/auth.pb';
import { Icon, IconName } from '@frontend/icons';
import { useTaskCenterStore } from '@frontend/task-center-scope';
import { usePopoverDialog, PopoverDialog, Avatar, Text, Button, Dot } from '@frontend/design-system';
import { taskCenterTrackingIds } from '../../tracking-ids';
import { getFullName } from '../../utils';
import { PersonSearchableListbox } from '../common';
import { filtersButtonStyle } from './common-styles';
import { iconLeftSpacing, popoverStyle } from './task-person-filter.styles';

interface TaskPersonFilterProps {
  setValue: (value: string) => void;
  selectedValue: string;
  label: string;
  iconName?: IconName;
}

export const TaskPersonFilter: FC<TaskPersonFilterProps> = ({ setValue, selectedValue, label, iconName }) => {
  const { assignees } = useTaskCenterStore(['assignees']);
  const { getDialogProps, getTriggerProps, close } = usePopoverDialog();

  return (
    <span>
      <Button
        variant='secondary'
        css={filtersButtonStyle}
        {...getTriggerProps()}
        trackingId={taskCenterTrackingIds.filters.createdByFilter}
      >
        <Icon name={iconName ?? 'user'} size={16} />
        <Text weight='regular'>{label}</Text>
        {selectedValue && (
          <Dot
            color='primary'
            css={css`
              position: relative;
            `}
          />
        )}
        <Icon name='alt-caret-right-tiny' color='subdued' css={iconLeftSpacing} />
      </Button>
      <PopoverDialog {...getDialogProps()} css={popoverStyle}>
        <PersonSearchableListbox<UserDetails>
          data={assignees}
          renderItem={(item) => {
            const name = getFullName(item);
            return (
              <>
                <Avatar size='xs' name={name} /> <Text size='large'>{name}</Text>
              </>
            );
          }}
          keyGen={(item) => `searchable-${item.userId}`}
          getItemValue={(item) => item.userId ?? ''}
          value={selectedValue}
          onSelect={(value: string | string[]) => {
            setValue(Array.isArray(value) ? value[0] : value);
            close();
          }}
          getSearchValue={(item) => getFullName(item)}
        />
      </PopoverDialog>
    </span>
  );
};
